import { FunctionComponent, Fragment } from 'react';
import { FlexContainer } from '@/components/Layout/Container';
import {
    IntegrationConfiguration,
    ProductConfiguration,
} from '@/models/product';
import { styled, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const configKeyTranslation = {
    barcode: 'E-Ticket (Zutritt mit Barcode / QR Code Scanner)',
    internalProduction: 'Produktion und Versand durch die Bergbahn',
    keycard: 'Keycard',
    pickup: 'Pick-up-Voucher (Abholung Automat oder Kassa)',
};

const configurationHasActiavtedKey = (
    configurartion: IntegrationConfiguration
) => Object.values(configurartion).some((c) => c);

export const ProductConfigurationOverview: FunctionComponent<
    React.PropsWithChildren<{
        productConfiguration: ProductConfiguration;
    }>
> = ({ productConfiguration }) => {
    const {
        integrationConfiguration,
        mobileConfiguration,
        portalConfiguration,
        b2bConfiguration,
    } = productConfiguration;
    return (
        <FlexContainer
            sx={{
                width: 480,
            }}
            justifyContent='center'
            column
        >
            {productConfiguration.enabled && (
                <Row>
                    <CheckIcon />
                    Produkt aktiv zum Kauf
                </Row>
            )}

            {productConfiguration.startDateValidityRange.to &&
                productConfiguration.startDateValidityRange.from && (
                    <Row>Start Date Validity</Row>
                )}

            {productConfiguration.maxTicketsPerStartDay && (
                <Row gutterBottom>
                    <CheckIcon />
                    Kontingent aktiv
                </Row>
            )}

            <Row>
                <CheckIcon />
                Aktivierte Buchungsarten in Verkaufskanälen
            </Row>

            {configurationHasActiavtedKey(portalConfiguration) && (
                <BookingMethod
                    configurationTitle='starjack.at & starjack App:'
                    integrationConfiguration={portalConfiguration}
                />
            )}

            {configurationHasActiavtedKey(mobileConfiguration) && (
                <BookingMethod
                    configurationTitle='Webshop auf meiner mobilen Website:'
                    integrationConfiguration={mobileConfiguration}
                />
            )}

            {configurationHasActiavtedKey(integrationConfiguration) && (
                <BookingMethod
                    configurationTitle='Webshop auf meiner Webseite:'
                    integrationConfiguration={integrationConfiguration}
                />
            )}

            {configurationHasActiavtedKey(b2bConfiguration) && (
                <BookingMethod
                    configurationTitle='starjack.hospitality:'
                    integrationConfiguration={b2bConfiguration}
                />
            )}
        </FlexContainer>
    );
};

const CheckIcon = styled(CheckCircleIcon)(({ theme }) => ({
    color: theme.palette.success.main,
    marginRight: theme.spacing(2),
}));

const Row = styled(Typography)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
}));

const BookingMethod: FunctionComponent<
    React.PropsWithChildren<{
        configurationTitle: string;
        integrationConfiguration: IntegrationConfiguration;
    }>
> = ({ configurationTitle, integrationConfiguration }) => {
    const activatedKeys = Object.keys(integrationConfiguration).filter(
        (c) => integrationConfiguration[c]
    );
    return (
        <FlexContainer
            sx={{
                width: '100%',
                ml: 8,
                mb: 2,
            }}
            column
        >
            <Typography variant='subtitle2'>{configurationTitle}</Typography>
            <FlexContainer
                sx={{
                    display: 'flex',
                    width: '100%',
                    flexWrap: 'wrap',
                    ml: 2,
                }}
            >
                {activatedKeys.map((key, i) => (
                    <Fragment key={i}>
                        <Typography>{configKeyTranslation[key]}</Typography>
                        {i < activatedKeys.length - 1 && (
                            <Typography>,&nbsp;</Typography>
                        )}
                    </Fragment>
                ))}
            </FlexContainer>
        </FlexContainer>
    );
};
